import React, { ReactNode } from 'react';
import { Tooltip as BootstrapTooltip, OverlayTrigger } from 'react-bootstrap';

export default function QuestionTooltip({
  id,
  hoverText,
}: {
  id: string;
  hoverText: ReactNode;
}) {
  const tooltip = <BootstrapTooltip id={id}>{hoverText}</BootstrapTooltip>;
  return (
    <OverlayTrigger
      placement='right'
      overlay={tooltip}
      delayShow={250}
      delayHide={400}
    >
      <i className='fa fa-question-circle' />
    </OverlayTrigger>
  );
}
